export const searchFormOption = function () {
    return [
        {
            prop: 'orgId',
            label: '所属机构',
            type: 'cascader',
            placeholder: '请选择所属机构',
            propConfig: {
                children: 'children',
                label: 'orgName',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
            },
            options: this.orgOption
        },
        {
            prop: 'date',
            label: '交费日期',
            type: 'range-date',
        },
    ]
}

export default {}